var Model = require('../Model');
var model = Object.create(Model);

model.name = 'BacnetProperty';
model['@class'] = 'BacnetProperty';
model.url = 'bacnetproperty';
model.parentClass = 'Resource';
model.isNetworkModel = true;

model.fields = {
  parent: {
    default: null,
    hidden: true
  },
  name: {
    type: 'text',
    default: null,
  },
  propertyId: {
    type: 'text',
    default: null,
  },
  error: {
    default: null,
    hiden: true
  },
  lastError: {
    default: null,
    hiden: true
  },
  status: {
    default: null,
    hidden: true
  },
  calendarEvents: {
    default: []
  },
  isChunk: {
    type: 'select',
    default: 0,
    options: [
      {name: 'True', value: 1},
      {name: 'False', value: 0},
    ]
  },
  enumeration: {
    default: null
  },
  dataChunk: {
    default: []
  },
  interval: {
    type: 'number',
    default: 0
  },
  pollGroup: {
    default : null,
    hidden: true
  },
  updated: {},
  polled: {},
  lastOfflineTimestamp: {},
  bacnetWritePriority: {
    type: 'number',
    default: 8
  }
};

module.exports = model;
